import { useEffect, useState } from 'react';
import { useTRPC } from '../../../hooks/useTRPC';
import { captureAndReportError } from '../../../utils/errorReporting';
import { isExternalUrl } from '../../../utils/urlUtils';

export function useApkDownloadUrl(releaseFileUrl: string | null | undefined) {
  const trpc = useTRPC();
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);

  useEffect(() => {
    const setupDownloadUrl = async () => {
      if (!releaseFileUrl) {
        setDownloadUrl(null);
        return;
      }

      if (isExternalUrl(releaseFileUrl)) {
        setDownloadUrl(releaseFileUrl);
      } else {
        try {
          const result = await trpc.getPresignedUrl.query({
            url: releaseFileUrl,
          });
          if (result._tag === 'Right') {
            setDownloadUrl(result.right.presignedUrl);
          }
        } catch (err) {
          captureAndReportError('Error getting presigned URL:', err);
        }
      }
    };

    setupDownloadUrl();
  }, [releaseFileUrl, trpc]);

  return downloadUrl;
}
